import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import NeoButton from "../../../../components/Common/NeoButton";
import NeoInput from "../../../../components/Common/NeoInput";
import NeoModal from "../../../../components/Common/NeoModal";
import NeoTabs from "../../../../components/Common/NeoTabs";
import FormPhotoUpload from "../../../../components/Common/FormPhotoUpload";
import { listPlans } from "../../../../services/platform_admin_service";

const getTodayISO = () => new Date().toLocaleDateString("en-CA");

const addDays = (isoDate, days) => {
    const date = new Date(`${isoDate}T12:00:00`);
    date.setDate(date.getDate() + days);
    return date.toLocaleDateString("en-CA");
};

const ClientFormModal = ({ isOpen, toggle, onSave }) => {
    const [activeTab, setActiveTab] = useState("1");
    const [plans, setPlans] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const initialTrialStartDate = getTodayISO();
    const initialTrialEndsAt = addDays(initialTrialStartDate, 15);
    const [form, setForm] = useState({
        name: "",
        corporateName: "",
        document: "",
        responsibleName: "",
        phone: "",
        email: "",
        password: "123456",
        zipCode: "",
        street: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: "",
        planId: "",
        status: "trial",
        trialStartDate: initialTrialStartDate,
        trialEndsAt: initialTrialEndsAt,
        photoUrl: ""
    });

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const result = await listPlans();
                const fetchedPlans = result.items || [];
                setPlans(fetchedPlans);
                if (fetchedPlans.length > 0) {
                    setForm(prev => ({ ...prev, planId: fetchedPlans[0].id }));
                }
            } catch (err) {
                console.error("Erro ao buscar planos:", err);
            }
        };

        if (isOpen) {
            const trialStartDate = getTodayISO();
            const trialEndsAt = addDays(trialStartDate, 15);
            setActiveTab("1");
            setSubmitting(false);
            setForm({
                name: "",
                corporateName: "",
                document: "",
                responsibleName: "",
                phone: "",
                email: "",
                password: "123456",
                zipCode: "",
                street: "",
                number: "",
                complement: "",
                neighborhood: "",
                city: "",
                state: "",
                planId: "",
                status: "trial",
                trialStartDate,
                trialEndsAt,
                photoUrl: ""
            });
            fetchPlans();
        }
    }, [isOpen]);

    const handleInputChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        try {
            setSubmitting(true);
            await onSave(form);
        } catch (err) {
            // Erro já é exibido via toast/alert no usePlatformTenants
        } finally {
            setSubmitting(false);
        }
    };

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const tabs = [
        { id: "1", label: "Dados da Empresa", icon: "mdi-office-building-outline" },
        { id: "2", label: "Responsável & Contato", icon: "mdi-account-circle-outline" },
        { id: "3", label: "Contratação", icon: "mdi-file-document-edit-outline" }
    ];

    const modalFooter = (
        <React.Fragment>
            <NeoButton
                variant="primary"
                icon={submitting ? undefined : "mdi-check"}
                onClick={handleSubmit}
                disabled={submitting}
            >
                {submitting ? "Cadastrando..." : "Finalizar Cadastro"}
            </NeoButton>
        </React.Fragment>
    );

    return (
        <NeoModal
            isOpen={isOpen}
            toggle={toggle}
            title="Cadastrar Novo Cliente"
            subtitle="Gestão completa do perfil e cadastro da nova academia no SaaS NeoApp."
            headerIcon="mdi-office-building-plus-outline"
            size="xl"
            footerActions={modalFooter}
        >
            {/* Abas Superiores Customizadas do Design System */}
            <div className="px-1 pt-1 text-center">
                <NeoTabs
                    tabs={tabs}
                    activeTab={activeTab}
                    onChangeTab={toggleTab}
                    style={{ marginBottom: '22px' }}
                />
            </div>

            {/* Conteúdo das Abas */}
            <div style={{ minHeight: "260px" }}>
                {/* TAB 1: DADOS DA EMPRESA */}
                {activeTab === "1" && (
                    <Row>
                        <Col lg={3} className="text-center mb-4">
                            <div className="p-3 bg-light rounded-4 h-100 d-flex flex-column align-items-center justify-content-center border border-dashed" style={{ borderColor: 'rgba(72, 39, 18, 0.15)' }}>
                                <label className="fw-bold text-muted small text-uppercase mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
                                    Logotipo / Foto
                                </label>
                                <FormPhotoUpload
                                    photoPreview={form.photoUrl}
                                    onChange={(url) => handleInputChange("photoUrl", url)}
                                    size="lg"
                                />
                            </div>
                        </Col>
                        <Col lg={9}>
                            <div className="bg-white p-1">
                                <h6 className="text-uppercase font-size-11 fw-bold text-muted mb-4" style={{ letterSpacing: '0.5px' }}>
                                    Informações Corporativas
                                </h6>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <NeoInput 
                                            label="Nome da Academia / Fantasia *" 
                                            placeholder="Ex: A2 Aquática"
                                            value={form.name} 
                                            onChange={(e) => handleInputChange("name", e.target.value)} 
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <NeoInput 
                                            label="Razão Social" 
                                            placeholder="Ex: A2 Aquática Fitness Ltda"
                                            value={form.corporateName} 
                                            onChange={(e) => handleInputChange("corporateName", e.target.value)} 
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <NeoInput 
                                            label="CNPJ ou CPF *" 
                                            placeholder="00.000.000/0001-00" 
                                            value={form.document} 
                                            onChange={(e) => handleInputChange("document", e.target.value)} 
                                        />
                                    </Col>
                                </Row>

                                <h6 className="text-uppercase font-size-11 fw-bold text-muted mb-3 mt-4" style={{ letterSpacing: '0.5px' }}>
                                    Endereço
                                </h6>
                                <Row className="g-3">
                                    <Col md={3}>
                                        <NeoInput 
                                            label="CEP" 
                                            placeholder="00000-000"
                                            value={form.zipCode} 
                                            onChange={(e) => handleInputChange("zipCode", e.target.value)} 
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <NeoInput 
                                            label="Rua / Logradouro" 
                                            placeholder="Ex: Avenida Beira Mar"
                                            value={form.street} 
                                            onChange={(e) => handleInputChange("street", e.target.value)} 
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <NeoInput 
                                            label="Número" 
                                            placeholder="Ex: 1200"
                                            value={form.number} 
                                            onChange={(e) => handleInputChange("number", e.target.value)} 
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <NeoInput 
                                            label="Complemento" 
                                            placeholder="Ex: Sala 201"
                                            value={form.complement} 
                                            onChange={(e) => handleInputChange("complement", e.target.value)} 
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <NeoInput 
                                            label="Bairro" 
                                            placeholder="Ex: 13 de Julho"
                                            value={form.neighborhood} 
                                            onChange={(e) => handleInputChange("neighborhood", e.target.value)} 
                                        />
                                    </Col>
                                    <Col md={5}>
                                        <NeoInput 
                                            label="Cidade *" 
                                            placeholder="Ex: Aracaju"
                                            value={form.city} 
                                            onChange={(e) => handleInputChange("city", e.target.value)} 
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <NeoInput 
                                            label="Estado (UF) *" 
                                            placeholder="SE" 
                                            maxLength={2} 
                                            value={form.state} 
                                            onChange={(e) => handleInputChange("state", e.target.value)} 
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                )}

                {/* TAB 2: RESPONSÁVEL & CONTATO */}
                {activeTab === "2" && (
                    <div className="bg-white p-1">
                        <h6 className="text-uppercase font-size-11 fw-bold text-muted mb-4 d-flex align-items-center" style={{ letterSpacing: '0.5px' }}>
                            <i className="mdi mdi-account-circle-outline me-2 text-primary font-size-16"></i>
                            Responsável Financeiro & Contato
                        </h6>
                        <Row className="g-3">
                            <Col md={4}>
                                <NeoInput 
                                    label="Nome do Responsável *" 
                                    placeholder="Ex: Felipe Macedo"
                                    value={form.responsibleName} 
                                    onChange={(e) => handleInputChange("responsibleName", e.target.value)} 
                                />
                            </Col>
                            <Col md={3}>
                                <NeoInput 
                                    label="WhatsApp *" 
                                    placeholder="(00) 90000-0000" 
                                    value={form.phone} 
                                    onChange={(e) => handleInputChange("phone", e.target.value)} 
                                />
                            </Col>
                            <Col md={3}>
                                <NeoInput 
                                    label="E-mail Administrativo *" 
                                    type="email" 
                                    placeholder="contato@empresa.com"
                                    value={form.email} 
                                    onChange={(e) => handleInputChange("email", e.target.value)} 
                                />
                            </Col>
                            <Col md={2}>
                                <NeoInput 
                                    label="Senha Inicial *" 
                                    type="text" 
                                    placeholder="Senha"
                                    value={form.password} 
                                    onChange={(e) => handleInputChange("password", e.target.value)} 
                                />
                            </Col>
                        </Row>
                    </div>
                )}

                {/* TAB 3: CONTRATAÇÃO */}
                {activeTab === "3" && (
                    <div className="bg-white p-1">
                        <h6 className="text-uppercase font-size-11 fw-bold text-muted mb-4 d-flex align-items-center" style={{ letterSpacing: '0.5px' }}>
                            <i className="mdi mdi-file-document-edit-outline me-2 text-primary font-size-16"></i>
                            Configurações de Contratação
                        </h6>
                        <Row className="g-3">
                            <Col md={form.status === "trial" ? 4 : 6}>
                                <NeoInput
                                    label="Plano de Contratação *"
                                    type="select"
                                    value={form.planId}
                                    onChange={(e) => handleInputChange("planId", e.target.value)}
                                    options={plans.length > 0 
                                        ? plans.map(p => ({ value: p.id, label: `${p.title} - R$ ${p.price}/mês` })) 
                                        : [{ value: "", label: "Carregando planos..." }]
                                    }
                                />
                            </Col>
                            <Col md={form.status === "trial" ? 4 : 6}>
                                <NeoInput
                                    label="Status Inicial *"
                                    type="select"
                                    value={form.status}
                                    onChange={(e) => handleInputChange("status", e.target.value)}
                                    options={[
                                        { value: "trial", label: "Em Teste Gratuito (Trial)" },
                                        { value: "active", label: "Ativo Imediatamente (Pago)" }
                                    ]}
                                />
                            </Col>
                            {form.status === "trial" && (
                                <React.Fragment>
                                    <Col md={6}>
                                        <NeoInput
                                            label="Início do Teste *"
                                            type="date"
                                            value={form.trialStartDate}
                                            onChange={(e) => handleInputChange("trialStartDate", e.target.value)}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <NeoInput
                                            label="Fim do Teste *"
                                            type="date"
                                            value={form.trialEndsAt}
                                            onChange={(e) => handleInputChange("trialEndsAt", e.target.value)}
                                        />
                                    </Col>
                                </React.Fragment>
                            )}
                        </Row>
                    </div>
                )}
            </div>
        </NeoModal>
    );
};

ClientFormModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
};

export default ClientFormModal;
